export class RequestError extends Error {

    statusCode;

    data;

    constructor(statusCode, message = null) {
        super(message);
        this.statusCode = statusCode;
    }
}
